import { Injectable } from '@angular/core';
import { ApiHttpClient } from '../modules/tcm-core.module';

@Injectable({
  providedIn: 'root'
})
export class InsuranceSubscriberDataService {
  constructor(private readonly httpClient: ApiHttpClient) {
  }

  public checkDefaultRelatedSubscriberExists(patientId: number, relatedSubscriberId: number): Promise<boolean> {
    const data = { patientId: patientId, relatedSubscriberId: relatedSubscriberId };

    return this.httpClient.getJsonAsync<boolean>('insuranceSubscribers/checkDefaultRelatedSubscriberExists', data);
  }
}
